/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getContextsOverrides';

export type GetContextsPathParams = NonNullable<operations['getContexts']['parameters']['path']>;

export type GetContextsQueryParams = NonNullable<operations['getContexts']['parameters']['query']>;

export interface Input extends GetContextsPathParams {
  apiVersion?: string;
  query?: GetContextsQueryParams;
}

export async function getContexts(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/contexts/{kind}/{key}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
